exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-outer-box {\n\n    min-height: 500px;\n}\n.search-outer-box img {\n    width: 100%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/setnewpassword/setnewpassword.component.css
// module id = ../../../../../src/app/home/setnewpassword/setnewpassword.component.css
// module chunks = common